<template>
  <svg
    :class="{ red: checked, gray: !checked }"
    class="cursor-pointer"
    @click.stop="toggleMarker"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2.0" />
      <path
        d="M8.5 12.5L10.5 14.5L15.5 9.5"
        stroke="currentColor"
        stroke-width="2.0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
<script>
import api from "@/default/utils/api";
export default {
  name: "ContainerMarker",
  mixins: [api],
  props: {
    item: {
      type: Object,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 20,
    },
  },
  data() {
    return {
      prefixes: {
        order: "o",
        route: "r",
      },
      isMarked: this.item.marker,
    };
  },
  mounted() {
    window.addEventListener(this.eventName, this.recieved);
  },
  beforeDestroy() {
    window.removeEventListener(this.eventName, this.recieved);
  },
  computed: {
    global() {
      return this.$store.envs.global_check_marker;
    },
    key() {
      const { target, id } = this.item;
      return `${this.prefixes[target]}${id}`;
    },
    eventName() {
      return `${this.item.target}-${this.item.id}-marker`;
    },
    checked() {
      if (this.global) {
        return this.isMarked;
      } else {
        var time = 0;
        const markers = this.$store.checkMarkers;
        if (markers.hasOwnProperty(this.key)) {
          time = markers[this.key];
        }
        return time > 0;
      }
    },
  },
  methods: {
    async toggleMarker() {
      try {
        if (this.global) {
          let { id, target } = this.item;
          let params = { id, type: target, marker: !this.isMarked };
          const response = await this.$http.post(
            `/api/v1/check_markers/toggle`,
            params
          );
          this.isMarked = response.data.marker;
        } else {
          this.syncCheckMarkers(this.key, this.checked ? "unmark" : "mark");
        }
      } catch (ex) {}
    },
    recieved(event) {
      this.isMarked = event.detail.marker;
    },
  },
};
</script>
